module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-cell",
    class: {
      'vux-tap-active': _vm.isLink || !!_vm.link,
        'weui-cell_access': _vm.isLink || !!_vm.link,
        'vux-cell-no-border-intent': !_vm.borderIntent,
        'vux-cell-disabled': _vm.disabled
    },
    style: (_vm.style),
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_vm._t("icon")], 2), _vm._v(" "), _c('div', {
    staticClass: "vux-cell-bd",
    class: {
      'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'
    }
  }, [_c('p', [(_vm.title || _vm.hasTitleSlot) ? _c('label', {
    staticClass: "vux-label",
    class: _vm.labelClass,
    style: (_vm.getLabelStyles())
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2) : _vm._e(), _vm._v(" "), _vm._t("after-title")], 2), _vm._v(" "), _c('inline-desc', [_vm._t("inline-desc", [_vm._v(_vm._s(_vm.inlineDesc))])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft",
    class: _vm.valueClass
  }, [_vm._t("value"), _vm._v(" "), _vm._t("default", [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), (_vm.isLoading) ? _c('i', {
    staticClass: "weui-loading"
  }) : _vm._e()], 2), _vm._v(" "), _vm._t("child")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aae23878"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/cell/index.vue
// module id = 209
// module chunks = 1